export default {
  wrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    marginBottom: 10,
  },
};
